/**
 * @fileoverview App principal: ParticipacionProvider + router + Toaster.
 * Las 8 pantallas se conectan a través del contexto.
 */

import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ParticipacionProvider } from "./context/ParticipacionContext";
import { Confirmacion } from "./pages/Confirmacion";
import { DatosDemograficos } from "./pages/DatosDemograficos";
import { Inicio } from "./pages/Inicio";
import { Reanudar } from "./pages/Reanudar";
import { RespuestaAbierta } from "./pages/RespuestaAbierta";
import { ResumenFinal } from "./pages/ResumenFinal";
import { Salida } from "./pages/Salida";
import { Votacion } from "./pages/Votacion";

function App() {
    return (
        <BrowserRouter>
            <ParticipacionProvider>
                <Routes>
                    <Route path="/" element={<Inicio />} />
                    <Route path="/reanudar" element={<Reanudar />} />
                    <Route path="/datos-demograficos" element={<DatosDemograficos />} />
                    <Route path="/votacion" element={<Votacion />} />
                    <Route path="/respuesta-abierta" element={<RespuestaAbierta />} />
                    <Route path="/resumen-final" element={<ResumenFinal />} />
                    <Route path="/confirmacion" element={<Confirmacion />} />
                    <Route path="/salida" element={<Salida />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Toaster position="top-center" richColors />
            </ParticipacionProvider>
        </BrowserRouter>
    );
}

export default App;
